import { Environment } from '~/engine/data/Environment';
import { RegionOfInterest } from '~/engine/data/structure/RegionOfInterest';
import type { ApplyComputedGeometryDeps } from '~/hooks/structure-set/applyComputedGeometry';
import { recordContourEdit } from '~/hooks/structure-set/recordContourEdit';
import type { useGetOrCreateDestination } from './useGetOrCreateDestination';

type GetOrCreateDestination = ReturnType<
    typeof useGetOrCreateDestination
>['getOrCreateDestination'];

/**
 * The toolbar's shared `applyComputedGeometry` binding: create the new
 * destination with the input ROI's derived color, refresh through the
 * toolbar's own view updater, and record the audited edit against the live
 * structure set. One copy so the margin/ring handlers cannot drift.
 */
export function makeApplyGeometryDeps(options: {
    environment: Environment | null;
    inputRoi: RegionOfInterest | undefined;
    updateView: () => void;
    getOrCreateDestination: GetOrCreateDestination;
}): ApplyComputedGeometryDeps {
    const { environment, inputRoi, updateView, getOrCreateDestination } =
        options;
    return {
        createDestinationRoi: async (name) =>
            (await getOrCreateDestination(null, name, inputRoi)) ?? null,
        triggerContourLayerUpdate: updateView,
        recordContourEdit: (dest) =>
            recordContourEdit(environment?.structureSet?.sopInstanceUID, dest),
    };
}
